import { BrowserCacheLocation, LogLevel } from '@azure/msal-browser';

import { entryPage } from 'features/order-tracker/router/path-constants';

const REACT_APP_SAF_SCOPES = import.meta.env.VITE_SAF_SCOPES || '';
const REACT_APP_SAF_SCOPE_PREFIX = import.meta.env.VITE_SAF_SCOPE_PREFIX || '';
const REACT_APP_SAF_CLIENT_ID = import.meta.env.VITE_SAF_CLIENT_ID || '';
const REACT_APP_SAF_AUTHORITY = import.meta.env.VITE_SAF_AUTHORITY || '';
const REACT_APP_SAF_KNOWN_AUTHORITY = import.meta.env.VITE_SAF_KNOWN_AUTHORITY || '';
const REACT_APP_MY_ACCOUNT_DOMAIN = import.meta.env.VITE_MY_ACCOUNT_DOMAIN || '';
const REACT_APP_SAF2_AUTHORITY = import.meta.env.VITE_SAF2_AUTHORITY || '';
const ENABLE_SAF_STAGE2 = import.meta.env.VITE_ENABLE_SAF_STAGE2;

export const USER_SCOPES = REACT_APP_SAF_SCOPES.split(';').map((scope) => REACT_APP_SAF_SCOPE_PREFIX + scope);
const isSafStage2 = ENABLE_SAF_STAGE2?.trim() === 'true';
const authority = isSafStage2 ? REACT_APP_SAF2_AUTHORITY : REACT_APP_SAF_AUTHORITY;

export const msalConfig = {
  auth: {
    clientId: REACT_APP_SAF_CLIENT_ID,
    authority,
    knownAuthorities: [REACT_APP_SAF_KNOWN_AUTHORITY],
    redirectUri: `${window.location.origin}${entryPage}/`,
    postLogoutRedirectUri: REACT_APP_MY_ACCOUNT_DOMAIN,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    allowRedirectInIframe: true,
    loggerOptions: {
      logLevel: LogLevel.Verbose,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        if (LogLevel.Error === level) {
          console.error(message);
        }
      },
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: USER_SCOPES,
};

export const refreshTokenRequest = {
  scopes: USER_SCOPES,
  forceRefresh: true,
};
